import { Brands } from "@/brand/brandConfig";

export const CROSS_SELL_SOURCE_GROUP = Object.freeze({
    Penrose: 'penrose',
    Rgs: 'rgs',
});

export const CROSS_SELL_PRIORITY_BY_SOURCE_GROUP = Object.freeze({
    [CROSS_SELL_SOURCE_GROUP.Penrose]: Object.freeze([
        'blg',
        'fantasy',
        'rush-games',
        'game-rush',
        'gameapp-world',
    ]),
    [CROSS_SELL_SOURCE_GROUP.Rgs]: Object.freeze([
        'game-rush',
        'gameapp-world',
        'blg',
        'fantasy',
        'rush-games',
    ]),
});

export const crossSellConfig = [
    {
        brand: Brands.BattleLeaugeGamingMFilter,
        assetBrand: 'blg-en-mfilter',
        sourceGroup: CROSS_SELL_SOURCE_GROUP.Penrose,
        serviceFamily: 'blg',
        flowType: 'mfilter',
        productId: 318,
        campaignId: 251103003,
        title: 'Battle League Gaming',
        bodyText: 'Premium tournaments, bigger rewards, and a new level of play. Get Gaming Now, are you ready to WIN?',
        gameUrl: 'https://ke-mplay.blg.gg/thank-you',
        errorUrl: 'https://ke-mplay.blg.gg/error',
        platformUrl: 'https://ke.blg.gg',
        pricePoint: 'Battle_League_Gaming',
        billingText: '20 KSH/day',
        offerCode: '001050038683',
        mFilterOfferCode: '1771414341279',
        mfilterRedirectUrl: 'https://ke-mplay.blg.gg',
    },
    {
        brand: Brands.FantasySoccerMFilter,
        assetBrand: 'fantasy-soccer-en',
        sourceGroup: CROSS_SELL_SOURCE_GROUP.Penrose,
        serviceFamily: 'fantasy',
        flowType: 'mfilter',
        productId: 320,
        campaignId: 251103002,
        title: 'Fantasy Sports',
        bodyText: 'Build your dream team, compete in live matches, and WIN big. Get Gaming Now, are you ready to WIN?',
        gameUrl: 'https://ke-mplay.fantasyfootball.one/thank-you',
        errorUrl: 'https://ke-mplay.fantasyfootball.one/error',
        platformUrl: 'https://ke.fantasyfootball.one',
        pricePoint: 'Fantasy_Sports',
        billingText: '15 KSH/day',
        offerCode: '001050038707',
        mFilterOfferCode: '1775218274245',
        mfilterRedirectUrl: 'https://ke-mplay.fantasyfootball.one',
    },
    {
        brand: Brands.RushGamesMFilter,
        assetBrand: 'rush-games-en',
        flowType: 'mfilter',
        sourceGroup: CROSS_SELL_SOURCE_GROUP.Penrose,
        serviceFamily: 'rush-games',
        productId: 319,
        campaignId: 251103001,
        title: 'Rush Games',
        bodyText: 'Dive into quick-fire challenges and earn rewards. Get Gaming Now, are you ready to WIN?',
        gameUrl: 'https://ke-mplay.yellowrush.co.za/thank-you',
        errorUrl: 'https://ke-mplay.yellowrush.co.za/error',
        platformUrl: 'https://ke.yellowrush.co.za',
        pricePoint: 'Rush_Games',
        billingText: '20 KSH/day',
        offerCode: '001050038706',
        mFilterOfferCode: '1775218399877',
        mfilterRedirectUrl: 'https://ke-mplay.yellowrush.co.za',
    },
    {
        brand: Brands.GameRushMFilter,
        assetBrand: 'game-rush-mfilter',
        flowType: 'mfilter',
        sourceGroup: CROSS_SELL_SOURCE_GROUP.Rgs,
        serviceFamily: 'game-rush',
        productId: 324,
        campaignId: 251103004,
        title: 'Game Rush',
        bodyText: 'GameRush - one platform, limitless fun. Play unlimited HTML games anywhere!',
        gameUrl: 'https://rgs-gr-wr.goodgamingco.com/thank-you',
        errorUrl: 'https://rgs-gr-wr.goodgamingco.com/error',
        platformUrl: 'https://sfc_ke.gamerush.zone',
        pricePoint: 'Game_Rush',
        billingText: '15 KSH/day',
        offerCode: '001050038720',
        mFilterOfferCode: '1773911963520',
        mfilterRedirectUrl: 'https://rgs-gr-wr.goodgamingco.com',
    },
    {
        brand: Brands.GameAppWorldMFilter,
        assetBrand: 'gameapp-world-en',
        flowType: 'mfilter',
        sourceGroup: CROSS_SELL_SOURCE_GROUP.Rgs,
        serviceFamily: 'gameapp-world',
        productId: 322,
        campaignId: 251103005,
        title: 'GameApp World',
        bodyText: 'GameApp World where every click unlocks a new thrilling gaming adventure!',
        gameUrl: 'https://rgs-gaw-wr.goodgamingco.com/thank-you',
        errorUrl: 'https://rgs-gaw-wr.goodgamingco.com/error',
        platformUrl: 'https://sfc_ke.gameappworld.zone',
        pricePoint: 'GameApp_World',
        billingText: '20 KSH/day',
        offerCode: '001050038670',
        mFilterOfferCode: '1771585616843',
        mfilterRedirectUrl: 'https://rgs-gaw-wr.goodgamingco.com',
    }
]

export function getCrossSellPriorityOrder(sourceGroup) {
    return CROSS_SELL_PRIORITY_BY_SOURCE_GROUP[sourceGroup] ?? CROSS_SELL_PRIORITY_BY_SOURCE_GROUP[CROSS_SELL_SOURCE_GROUP.Penrose];
}
